var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-yu-shang-home"},[_c('VoteList',{attrs:{"id":_vm.id}}),_c('van-popup',{attrs:{"closeable":""},model:{value:(_vm.ruleShow),callback:function ($$v) {_vm.ruleShow=$$v},expression:"ruleShow"}},[_c('div',{staticClass:"rule-box",domProps:{"innerHTML":_vm._s(_vm.ruleData)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }